import axios from '@/libs/axios'

export default {

  namespaced: true,

  state: {
    unitCategory: null,
    unitCategories: [],
    unitCategoryNames: [],
    unitCategoryNamesPictures: [],
    unitCategoryNamesPackagesPictures: [],
  },

  getters: {

    unitCategory(state) {
      return state.unitCategory
    },
    unitCategories(state) {
      return state.unitCategories
    }
  },

  mutations: {

    SET_UNIT_CATEGORY(state, value) {
      state.unitCategory = value
    },
    SET_UNIT_CATEGORIES(state, value) {
      state.unitCategories = value
    },
    UPDATE_UNIT_CATEGORIES(state, data) {
      const index = state.unitCategories.findIndex(unitCategory => unitCategory.id == data.id);
      Object.assign(state.unitCategories[index], data);
    },
    ADD_UNIT_CATEGORY(state, data) {
      state.unitCategories.unshift(data);
    },
    DELETE_UNIT_CATEGORY(state, id) {
      state.unitCategories.forEach((unitCategory) => {
        if (String(unitCategory.parent_category_id) === String(id)) {
          unitCategory.parent_category_id = null
        }
      })
      const index = state.unitCategories.findIndex(unitCategory => String(unitCategory.id) === String(id))
      if (index !== -1) {
        state.unitCategories.splice(index, 1)
      }
    },
  },

  actions: {

    async loadUnitCategory({ commit }, unitCategoryId) {
      try {
        const response = await axios.get(`api/unitCategories/${unitCategoryId}`);
        commit('SET_UNIT_CATEGORY', response.data);
        return response.data;
      } catch (error) {
        console.error('Error loading unitCategory:', error);
        throw error;  // Handle the error if needed
      }
    },
    loadUnitCategories({ commit }) {
      return axios.get('api/unitCategories').then(response => {
        commit('SET_UNIT_CATEGORIES', response.data.data)
      })
    },
    updateUnitCategory({ commit }, { formData }) {
      return axios.post(`api/unitCategories/${formData.get('id')}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then((response) => {
        console.log('response.data.data', response.data.data);
        commit('UPDATE_UNIT_CATEGORIES', response.data.data)
      })
    },
    async searchUnitCategory({ commit }, keyword) {

      console.log('keyword=', keyword);
      return await axios.post(`api/unitCategories/search`,
  {
          keyword: keyword
        }
      ).then((response) => {
        console.log('response.data.data', response.data.data);
        return response.data;
      })
    },
    addUnitCategory({ commit }, { formData }) {
      return axios.post(`api/unitCategories`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then((response) => {
        commit('ADD_UNIT_CATEGORY',  response.data.data);
      })
    },
    deleteUnitCategory({ commit }, id) {
      return axios.delete(`api/unitCategories/${id}`).then(() => {
        commit('DELETE_UNIT_CATEGORY', id)
      })
    },
  },
}
